import { CapoPlugin } from "/home/runner/work/fincs-webfront/fincs-webfront/src/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];